import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';

const Application = ({ application }) => {
  const navigate = useNavigate(); // Hook to navigate

  const handleClick = () => {
    // Navigate to the ApplicationEdit page with the application ID
    navigate(`/applications/edit/${application._id}`);
  };

  return (
    <Card sx={{ boxShadow: 3, borderRadius: 2, cursor: 'pointer' }} onClick={handleClick}>
      <CardMedia
        component="img"
        image={application.photo?.link}
        alt={`${application.name}'s photo`}
        sx={{ height: 200 }}
      />
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {application.name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Email: {application.email}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Phone: {application.phone}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default Application;
